import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./setup/i18n";
import "@socotec.io/socio-vue-components/style.css";
import { createOidc, useOidcStore } from "vue3-oidc";
import vuetify from "./setup/vuetify";

import SocioManifest from "../socio-manifest.json";
import PackageJson from "../package.json";
import SocioVueComponents, { initializeTracingAndLogging } from "@socotec.io/socio-vue-components";
import { createORM } from "pinia-orm";
import { createPinia } from "pinia";
import { oidcSettings } from "./setup/OIDCSettings";
import VueApexCharts from "vue3-apexcharts";

const faroSettings = {
  enableTelemetry: import.meta.env.VITE_APP_ENABLE_TELEMETRY,
  grafanaApiKey: import.meta.env.VITE_APP_GRAFANA_API_KEY,
  collectorUrl: import.meta.env.VITE_APP_COLLECTOR_URL,
  propagateUrls: import.meta.env.VITE_APP_PROPAGATE_URLS,
  grpcApiEnv: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  faroLogLevel: import.meta.env.VITE_APP_FARO_LOG_LEVEL,
};

initializeTracingAndLogging(SocioManifest, PackageJson, faroSettings, {
  router,
});
createOidc({
  oidcSettings,
  auth: false,
  events: {
    addUserLoaded: (user) => {
      useOidcStore().actions.value.setUser(user);
    },
  },
  refreshToken: {
    enable: true,
    time: 30000,
  },
});

const app = createApp(App);
const pinia = createPinia().use(createORM());

app.use(pinia);

app
  .use(router)
  .use(i18n)
  .use(vuetify)
  .use(SocioVueComponents, i18n)
  .component("Apexchart", VueApexCharts)
  .mount("#app");
